import { render } from "./MPCMap.vue?vue&type=template&id=08bc7c32&scoped=true&ts=true"
import script from "./MPCMap.vue?vue&type=script&lang=ts"
export * from "./MPCMap.vue?vue&type=script&lang=ts"

import "./MPCMap.vue?vue&type=style&index=0&id=08bc7c32&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08bc7c32"]])

export default __exports__